<!--优惠券 添加/编辑form表单-->
<template>
    <v-card :color="theme.elementBgColor">
        <v-card-title>
            {{ form.id ? form.name + "--------" + "id：" + form.id : "添加优惠券" }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-3">
            <el-form :model="form" label-width="8em">
                <el-form-item label="名称" :rules="[{ required: true }]">
                    <el-input v-model="form.name" autocomplete="off">
                        <i class="el-icon-edit" slot="prepend"></i>
                    </el-input>
                </el-form-item>
                <el-form-item label="简介" :rules="[{ required: true }]">
                    <el-input
                        v-model="form.info"
                        type="textarea"
                        :autosize="{ minRows: 2, maxRows: 10 }"
                        clearable
                    >
                        <i class="el-icon-edit" slot="prepend"></i>
                    </el-input>
                </el-form-item>
                <el-form-item label="样式" :rules="[{ required: true }]">
                    <div style="display:flex;flex-direction:row;align-items:center;">
                        <upload-img
                            @upload="uploadBg"
                            :imgList="form.bg"
                            :limit="1"
                            :showText="'背景图'"
                            :site="false"
                        />
                        <upload-img
                            @upload="uploadIcon"
                            :imgList="form.icon"
                            :limit="1"
                            :showText="'图标'"
                            :site="false"
                        />
                    </div>
                </el-form-item>
                <el-form-item label="" :rules="[{ required: true }]">
                    <div style="display:flex;flex-direction:row;align-items:center;">
                        <div style="width:45%">
                            <el-form-item>
                                <el-input v-model="form.money" autocomplete="off" placeholder="">
                                    <span slot="prepend">面值(￥)</span>
                                </el-input>
                            </el-form-item>
                        </div>
                        <div style="width:10%"></div>
                        <div style="width:45%">
                            <el-form-item>
                                <el-input v-model="form.price" autocomplete="off" placeholder="">
                                    <span slot="prepend">价格(￥)</span>
                                </el-input>
                            </el-form-item>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="可用站点">
                    <el-tooltip
                        class="item"
                        effect="dark"
                        content="不选则全部站点可用"
                        placement="top-start"
                    >
                        <select-site
                            v-if="isSite"
                            :width="'100%'"
                            :selectSite="form.stations"
                            @choose="choose"
                            :multiple="true"
                        />
                    </el-tooltip>
                </el-form-item>
				<el-form-item v-if="role === 0" label="所属平台" :rules="[{ required: true }]">
				    <select-platform
				    	v-if="isPlatform"
				    	@choose="choosePlatformId"
				        :selectPlatform="form.platform_id"
				        :width="'100%'"
				    />
				</el-form-item>
                <el-form-item label="可使用次数" :rules="[{ required: true }]">
                    <el-radio
                        v-for="(item, index) in typeText"
                        :key="index"
                        v-model="form.type"
                        :label="item.id"
                    >
                        {{ item.value }}
                    </el-radio>
                </el-form-item>
                <el-form-item label="是否上架" :rules="[{ required: true }]">
                    <el-radio
                        v-for="(item, index) in validText"
                        :key="index"
                        v-model="form.valid"
                        :label="item.id"
                    >
                        {{ item.value }}
                    </el-radio>
                </el-form-item>
                <el-form-item label="有效期" :rules="[{ required: true }]">
                    <div style="width: 15vw">
                        <el-input v-model="form.expire" autocomplete="off" placeholder="有效期">
                            <span slot="append">天</span>
                        </el-input>
                    </div>
                </el-form-item>
                <el-form-item label="满减金额">
                    <div style="width: 15vw">
                        <el-input v-model="form.up" autocomplete="off" placeholder="金额">
                            <span slot="append">元</span>
                        </el-input>
                    </div>
                </el-form-item>
            </el-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="dialog-footer d-flex justify-space-around pb-5">
            <v-btn width="30%" @click="cancel()" class="float-left">取消</v-btn>
            <v-btn width="30%" color="primary" @click="determine()" class="float-right">
                确定
            </v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
import util from "@/util";
import Public from "@/public"
import SelectSite from "@/components/SelectSite";
import SelectPlatform from "@/components/SelectPlatform";
import UploadImg from "@/components/UploadImg";
import { mapState } from "vuex";
import store from "@/store";
export default {
    data() {
        return {
            isSite: true,
			isPlatform: true,
            showExpireInput: false, //是否显示有效期输入框
            form: {
                bg: [], //背景图片地址
                expire: null, //有效期（天）
                icon: [], //图标
                id: null,
                info: "",
                money: null, //面值（分）
                name: "",
                price: null, //价格（分）
                stations: [], //适用站点数组 null则为所有站点可用
                type: null, //使用次数 0-无限制 1-一次性
                valid: null, //是否上架 0无效  1有效
                up: null,  //优惠券满减（单位分）
				platform_id: null //所属平台
            },
            typeText: [
                {
                    id: 0,
                    value: "无限制",
                },
                {
                    id: 1,
                    value: "一次性",
                },
            ],
            validText: [
                {
                    id: 1,
                    value: "是",
                },
                {
                    id: 0,
                    value: "否",
                },
            ],
        };
    },
    props: {
        isAdd: Boolean,
        isEdit: Boolean,
        couponData: null,
    },
    created() {
        if (this.couponData != null) {
            Object.keys(this.couponData).forEach(key => {
                if (key == "expire") {
                    this.form[key] = this.couponData[key].toString();
                } else if (key == "money" || key == "price") {
                    this.form[key] = (this.couponData[key] / 100).toString();
                } else if (key == "bg" || key == "icon") {
                    this.form[key][0] = this.couponData[key];
                } else if (key == "stations") {
                    this.form[key] = this.JsonData(this.couponData[key]);
                } else if( key == "up" && this.couponData[key] != null) {
                    this.form[key] = (this.couponData[key] / 100).toString();
                } else {
                    this.form[key] = this.couponData[key];
                }
            });
        }
		if(this.role !== 0) {
			this.form["platform_id"] = this.platform_id;
		}
    },
    watch: {
        form() {
            this.isSite = false;
			this.isPlatform = false;
            this.$nextTick(() => {
                this.isSite = true;
				this.isPlatform = true;
            });
        },
    },
    computed: {
        ...mapState(["theme","role","platform_id"]),
    },
    components: {
        UploadImg,
        SelectSite,
		SelectPlatform
    },
    methods: {
        /*取消*/
        cancel() {
            this.$emit("cancel");
        },
        /*确定*/
        determine() {
            if (this.form.type === 0) {
                delete this.form.type;
            }
            if (this.form.valid === 0) {
                delete this.form.valid;
            }
            let params = {
                postData: { template: {} },
                callback: () => {
                    this.$emit("refresh");
                    this.cancel();
                },
            };
            let form = Object.assign({}, this.form);
            console.log(this.form["up"] == "")
            delete form.id;
            delete form.station_names;
            delete form.stations;
            delete form.price;
            delete form.up;
            let arr;
			console.log(form)
            if ((arr = Object.keys(form).filter(key => !form[key])).length <= 0) {
                Object.keys(this.form).forEach(key => {
                    if (key == "info" || key == "name") {
						params.postData.template[key] = Public.removeSpace(this.form[key])
                    } else if (key == "expire") {
                        params.postData.template[key] = Number(this.form[key]);
                    } else if (key == "money" || key == "price") {
                        params.postData.template[key] = Number(this.form[key]) * 100;
                    } else if (key == "bg" || key == "icon") {
                        params.postData.template[key] = this.form[key][0];
                    } else if (key == "stations") {
                        params.postData.template[key] = this.JsonData(this.form[key]);
                    } else if( key == "up" && this.form["up"] != null && this.form["up"] != "") {
                        params.postData.template[key] = Number(this.form[key]) * 100;
                    } else if( key == "up" && this.form["up"] == "") {
                        params.postData.template[key] = null;
                    } else if (this.isAdd && key != "id") {
                        params.postData.template[key] = this.form[key];
                    } else if (this.isEdit) {
                        params.postData.template[key] = this.form[key];
                    }
                    if (!this.form["valid"]) {
                        params.postData.template["valid"] = 0;
                    }
                    if (!this.form["type"]) {
                        params.postData.template["type"] = 0;
                    }
                });
            } else {
                util.ShowTip("必填项不能为空", 3);
                return;
            }
            if (this.isAdd && this.isEdit === false) {
                store.dispatch("addCoupon", params);
            } else if (this.isEdit && this.isAdd === false) {
                store.dispatch("updateCoupon", params);
            }
        },
        /*选择需要上传的图片*/
        uploadBg(data) {
            if (data.length == 0) {
                return;
            } else {
                this.form.bg = this.JsonData(data);
            }
        },
        uploadIcon(data) {
            if (data.length == 0) {
                return;
            } else {
                this.form.icon = this.JsonData(data);
            }
        },
        /*选择站点*/
        choose(site) {
            let siteData = this.JsonData(site);
            this.form.stations = siteData.siteIds;
            console.log(siteData);
        },
		/*选择平台*/
		choosePlatformId(e) {
			this.form.platform_id = e
		},
        JsonData(data) {
            return JSON.parse(JSON.stringify(data));
        },
        trim(str) {
            return str.replace(/(^\s*)|(\s*$)/g, "");
        },
    },
};
</script>
